module.exports = __webpack_public_path__ + "img/salon-value.a238302b.svg";